import { ExecutionRequestStatus } from "@/lib/interfaces and Enums/ENUMExecutionRequestStatus";
import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import { ColId } from "../ENUMActionSummaryColIds";
import { StructureTypeCode } from "@/lib/interfaces and Enums/ENUMStructureTypeCode";
import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { isNumericallyZero } from "@/lib/businessRules/zeroNormalizationHelper";
import quoteSnapshotStore, { QuoteSnapshotValue } from "@/store/quoteSnapshotStore";


export const defaultStatusCannotBeEdited = [
  // OP
  ExecutionStrategyStatus.Affirmed,
  ExecutionStrategyStatus.NotDealt,
  ExecutionStrategyStatus.Cancelled,
  // RP
  ExecutionRequestStatus.NotDealt,
  ExecutionRequestStatus.Archived,
  ExecutionRequestStatus.DealtAway,
  ExecutionRequestStatus.Affirmed,
  ExecutionRequestStatus.AffirmedPend,
];

export const statusWhenQuoteCellsCannotBeEdited = [
    // OP
  ExecutionStrategyStatus.Affirmed,
  ExecutionStrategyStatus.NotDealt,
  ExecutionStrategyStatus.Cancelled,
  // RP
  ExecutionRequestStatus.NotDealt,
  ExecutionRequestStatus.Archived,
  ExecutionRequestStatus.DealtAway,
  ExecutionRequestStatus.Executed,
  ExecutionRequestStatus.ExecutedPend,
  ExecutionRequestStatus.ExecutedRPChangeRequested,
  ExecutionRequestStatus.ExecutedPendRPChangeRequested,
  ExecutionRequestStatus.ExecutedRPAgreeChange,
  ExecutionRequestStatus.ExecutedPendRPAgreeChange,
  ExecutionRequestStatus.ExecutedOPChangeRequested,
  ExecutionRequestStatus.ExecutedPendOPChangeRequested,
  ExecutionRequestStatus.Affirmed,
  ExecutionRequestStatus.AffirmedPend,
]

//'statusFromAwarded' is assigned a value but never used. - Commented out until used. 11/04
// const statusFromAwarded = [
//   ExecutionRequestStatus.Awarded,
//   ExecutionRequestStatus.Executed,
//   ExecutionRequestStatus.ExecutedOPChangeRequested,
//   ExecutionRequestStatus.ExecutedPend,
//   ExecutionRequestStatus.ExecutedPendOPChangeRequested,
//   ExecutionRequestStatus.ExecutedPendRPAgreeChange,
//   ExecutionRequestStatus.ExecutedPendRPChangeRequested,
//   ExecutionRequestStatus.ExecutedRPAgreeChange,
//   ExecutionRequestStatus.ExecutedRPChangeRequested,
//   ExecutionRequestStatus.Affirmed,
//   ExecutionRequestStatus.AffirmedPend,
// ];

const statusWhenQuoteSizeCanBeEditedSYNREPO = [
  ExecutionRequestStatus.Awarded,
  // ExecutionRequestStatus.Executed,
  // ExecutionRequestStatus.ExecutedOPChangeRequested,
  // ExecutionRequestStatus.ExecutedPend,
  // ExecutionRequestStatus.ExecutedPendOPChangeRequested,
  // ExecutionRequestStatus.ExecutedPendRPAgreeChange,
  // ExecutionRequestStatus.ExecutedPendRPChangeRequested,
  // ExecutionRequestStatus.ExecutedRPAgreeChange,
  // ExecutionRequestStatus.ExecutedRPChangeRequested,
]

const statusWhenQuotedSizeCanBeEditedRegular = [
  ExecutionRequestStatus.Received,
  ExecutionRequestStatus.Quoted,
  ExecutionRequestStatus.OffQuote,
  ExecutionRequestStatus.ReQuoteRequested,
  ExecutionRequestStatus.QuotedExpired,
  ExecutionRequestStatus.QuoteExpired,
  ExecutionRequestStatus.ReSent,
]

const quotedSizeColId = [
  ColId.quotedSizeOutright,
  ColId.quotedSize,
]

const quoteCellsColId = [
  ColId.bidOutright,
  ColId.bid,
  ColId.bidRepo,
  ColId.askOutright,
  ColId.ask,
  ColId.askRepo,
  "ActionSummaryBid",
  "ActionSummaryAsk"
]


export function returnTrueIfCellCanBeEdited(
  status: any,
  colId?: ColId,
  role?: string,
  structureType?: StructureTypeCode,
  fullTradeData?: any,
  params?: any
) {

//Quote cells cannot be edited at Executed
  if(colId && 
    quoteCellsColId.includes(colId) && 
    statusWhenQuoteCellsCannotBeEdited.includes(status)) {
      return false
  }


  //IF NPV STRUCTURE cannot edit quoted size
  let tradeContainsNPVBlocksAll = false;
  if(params) {
    const { isOutright } =
       returnAllTradeDetailsFromGenericParams(params);

    tradeContainsNPVBlocksAll = fullTradeData?.legs?.length > 0 &&
    fullTradeData.legs.every((leg: any) => leg.unwind == "NPV") &&
    !isOutright
  }
  
  // if(tradeContainsNPVBlocksAll) {
  //   return false
  // }
   if(status && (status == ExecutionRequestStatus.AffirmedPend || status == ExecutionStrategyStatus.Affirmed)){
    return false
  }


  //SYN REPO AND SYN REV REPO cannot edit quoted size until Awarded
  // OTHER trades cannot edit quoted size after Awarded
  if(colId && quotedSizeColId.includes(colId)){
    if(structureType == StructureTypeCode.SYNREPO || structureType == StructureTypeCode.SYNREVREP || tradeContainsNPVBlocksAll){
      if(statusWhenQuoteSizeCanBeEditedSYNREPO.includes(status)){
        return true
      } return false
    } else {
      return statusWhenQuotedSizeCanBeEditedRegular.includes(status);
    }
  }

  




  //OTHER
  let statusCanBeEdited = true;
  if (colId && colId == ColId.book) {
    if (role == "OP") {
      statusCanBeEdited = false;
    } else if (role == "RP" && defaultStatusCannotBeEdited.includes(status)) {
      statusCanBeEdited = false;
    }
    return statusCanBeEdited;
  }

  //default
  if (defaultStatusCannotBeEdited.includes(status)) {
    statusCanBeEdited = false;
  }

  return statusCanBeEdited;
}

export function hasQuoteValue(value: QuoteSnapshotValue): boolean {
  if (value == null || value === "") return false;
  return !isNumericallyZero(value);
}

// LQC-1733: at Awarded an RP RFQ quote the server holds is locked (Go Off-Quote to adjust).
// Empty or 0 stays open, and typed values stay open as they never reach the snapshot.
export function isQuoteLockedAtAwarded(params: any): boolean {
  if (!params?.data) return false;
  const side: string | undefined = params.colDef?.field;
  if (side !== "bid" && side !== "ask") return false;

  const { fullTradeData, isLeg, isOp, isOrder } =
    returnAllTradeDetailsFromGenericParams(params);
  if (isOp || isOrder) return false;

  const status = isLeg ? params.data.statusER : params.data.status;
  if (status != ExecutionRequestStatus.Awarded) return false;

  const snapshot = quoteSnapshotStore.getState().quoteSnapshots[fullTradeData?.esid];
  if (!snapshot) return false;

  const sides = isLeg ? snapshot.blocks[params.data.blockId] : snapshot;
  return hasQuoteValue(sides?.[side]);
}

// Bid/ask cells only - every other column keeps calling returnTrueIfCellCanBeEdited.
export function returnTrueIfQuoteCellCanBeEdited(
  status: any,
  colId: ColId | string,
  params: any,
) {
  if (isQuoteLockedAtAwarded(params)) return false;
  return returnTrueIfCellCanBeEdited(status, colId as ColId);
}
